// /**** Development ****/
// const BASE_API = 'https://api.mycar-india.com';

// const BASE_API = 'https://api.auctionsoftware.in';

// export const environment = {
//   production: false,
//   authCheck_api: 'https://dms.mycar-india.com/api/',
//   // forntend_url: 'https://webadmin.mycar-india.com/',
//   forntend_url: 'http://localhost:4200/',
//   imgBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/gallery/images/',
//   auctionBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/auction/images/',
//   api: BASE_API + '/v1/',
//   newInventoryApi: BASE_API + '/',
//   payment_api: BASE_API + '/',
//   recycleApi: BASE_API + '/',
//   pdiAPI: BASE_API + '/v2/',
//   v4: BASE_API + '/v4/',
//   WS_API: 'wss://0amt97i2cc.execute-api.me-south-1.amazonaws.com/dev',
//   vamId: 'auction.user@gmail.com',
//   vamPassword: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
// };

/**** Production bckup****/

// const commonRoute = `https://tpy1nw2a0j.execute-api.me-south-1.amazonaws.com/prod/`;

// export const environment = {
//   production: true,
//   authCheck_api: 'https://dms.my-car.com/api/',
//   forntend_url: 'https://webadmin.my-car.com/',
//   imgBaseUrl: 'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/gallery/images/',
//   auctionBaseUrl: 'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/auction/images/',
//   api: 'https://om99y346bb.execute-api.me-south-1.amazonaws.com/prod/',
//   newInventoryApi: commonRoute,
//   payment_api: commonRoute,
//   recycleApi: commonRoute,
//   pdiAPI: 'https://kiuahte2h9.execute-api.me-south-1.amazonaws.com/prod/',
//   WS_API: 'wss://2qjnakl259.execute-api.me-south-1.amazonaws.com/prod',
//   vamId: 'auction.user@gmail.com',
//   vamPassword: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
// };

// Development

// const apiEndPoints = {
//   s1: ' https://inaxs1vayl.execute-api.me-south-1.amazonaws.com/dev/',
//   s2: ' https://upmx12usk5.execute-api.me-south-1.amazonaws.com/dev/',
//   s3: ' https://wdpzmt4mhb.execute-api.me-south-1.amazonaws.com/dev/',
//   s4: ' https://4uvwg5gw7h.execute-api.me-south-1.amazonaws.com/dev/',
//   wsapi:
//     'https://nxg7nqak3h.execute-api.me-south-1.amazonaws.com/prod/@connections',
// };

// export const environment = {
//   production: false,
//   envName: '',
//   authCheck_api: 'https://dms.mycar-india.com/api/',
//   // forntend_url: 'https://webadmin.mycar-india.com/',
//   forntend_url: 'https://newwebadmin.my-car.com/',
//   //   forntend_url: 'http://localhost:4200/',
//   imgBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/gallery/images/',
//   auctionBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/auction/images/',
//   api: apiEndPoints.s1,
//   newInventoryApi: apiEndPoints.s2,
//   payment_api: apiEndPoints.s2,
//   recycleApi: apiEndPoints.s2,
//   pdiAPI: apiEndPoints.s3,
//   v4: apiEndPoints.s4,
//   WS_API: apiEndPoints.wsapi,
//   vamId: 'auction.user@gmail.com',
//   vamPass
// word: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
// };

// ==========================================================================

// Dev

// const BASE_API = 'https://api.mycar-india.com';

// export const environment = {
//   production: false,
//   authCheck_api: 'https://dms.mycar-india.com/api/',
//   forntend_url: 'https://webadmin.mycar-india.com/',
//   client_frontend_url: 'https://develop.dffwldpfe1ly5.amplifyapp.com/',
//   imgBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/gallery/images/',
//   auctionBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/auction/images/',
//   api: BASE_API + '/v1/',
//   newInventoryApi: BASE_API + '/v2/',
//   payment_api: BASE_API + '/v2/',
//   recycleApi: BASE_API + '/v2/',
//   pdiAPI: BASE_API + '/v3/',
//   v4: BASE_API + '/v4/',
//   WS_API:
//     'https://nxg7nqak3h.execute-api.me-south-1.amazonaws.com/prod/@connections',
//   vamId: 'auction.user@gmail.com',
//   vamPassword: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
// };

// Staging

// const BASE_API = 'https://api.auctionsoftware.in';

// export const environment = {
//   production: false,
//   authCheck_api: 'https://dms.auctionsoftware.in/api/',
//   forntend_url: 'https://webadmin.auctionsoftware.in/',
//   client_frontend_url: 'https://staging.auctionsoftware.in/',
//   imgBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/gallery/images/',
//   auctionBaseUrl:
//     'https://s3.me-south-1.amazonaws.com/storage.siarty.com/storage/auction/images/',
//   api: BASE_API + '/v1/',
//   newInventoryApi: BASE_API + '/v2/',
//   payment_api: BASE_API + '/v2/',
//   recycleApi: BASE_API + '/v2/',
//   pdiAPI: BASE_API + '/v3/',
//   v4: BASE_API + '/v4/',
//   WS_API: 'wss://hd6hu5cho0.execute-api.me-south-1.amazonaws.com/stage',
//   vamId: 'auction.user@gmail.com',
//   vamPassword: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
// };

// staging(new)

const apiEndPoints = {
  s1: 'https://e513has561.execute-api.ap-south-1.amazonaws.com/stage/',
  s2: 'https://c93rthnz21.execute-api.ap-south-1.amazonaws.com/stage/',
  s3: 'https://afsruxjgm4.execute-api.ap-south-1.amazonaws.com/stage/',
  s4: 'https://jytzdqrl7d.execute-api.ap-south-1.amazonaws.com/stage/',
  s5: 'https://djv0yowp94.execute-api.ap-south-1.amazonaws.com/stage/',
  wsapi:
    'https://suwsq7j34l.execute-api.ap-south-1.amazonaws.com/stage/@connections',
};

export const environment = {
  production: true,
  authCheck_api: 'https://dms.mycar-india.com/api/',
  forntend_url: 'https://webadmin.mycar-india.com/',
  client_frontend_url: 'https://develop.d1dhdh6a1378nl.amplifyapp.com/',
  imgBaseUrl:
    'https://s3.ap-south-1.amazonaws.com/stage-storage-mycar-mumbai/storage/gallery/images/',
  auctionBaseUrl:
    'https://s3.ap-south-1.amazonaws.com/stage-storage-mycar-mumbai/storage/auction/images/',
  wsapi:
    'https://suwsq7j34l.execute-api.ap-south-1.amazonaws.com/stage/@connections',
  api: apiEndPoints.s1,
  newInventoryApi: apiEndPoints.s2,
  payment_api: apiEndPoints.s2,
  recycleApi: apiEndPoints.s2,
  pdiAPI: apiEndPoints.s3,
  v4: apiEndPoints.s4,
  v5: apiEndPoints.s5,
  WS_API: apiEndPoints.wsapi,
  vamId: 'auction.user@gmail.com',
  vamPassword: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
};
